/* Revolv buy block (cards) - draft theme, 2026-09-27. Used by snippets/revolv-buy-block.liquid.
   The theme option manager keeps choosing the variant; the theme form keeps adding to the cart.
   Checked accessories (rent list for the subscription, buy list for the purchase) are added to the cart
   just before the theme adds the bike, so the cart drawer shows everything together.
   Two modes, set by the shop metafield revolv.checkout ("hub" when empty):
   - hub (circuly Hub checkout): no selling plan; the cover is added by this block, without plan.
   - native (circuly Rental & Subscriptions app, Shopify checkout): the Subscribe variant, the rental accessories
     and the cover are added with their selling plan; a Subscribe variant without plan cannot be added.
   In both modes the Essential Upsell add-on (hidden) stays unchecked, so the cover is never added twice.
   On an unpublished theme, ?rv_checkout=native or ?rv_checkout=hub forces the mode for the browser session. */
/* 2026-09-28: cover added by this block in hub mode too (Essential Upsell add was unreliable with the cart drawer). */
(() => {
  if (!window.rvNative) {
    window.rvNative = function () {
      try {
        if (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') {
          const q = new URLSearchParams(window.location.search).get('rv_checkout');
          if (q === 'native' || q === 'hub') sessionStorage.setItem('rv_checkout', q);
          const forced = sessionStorage.getItem('rv_checkout');
          if (forced) return forced === 'native';
        }
      } catch (e) { /* storage unavailable */ }
      return window.rvCheckoutMode === 'native';
    };
  }
  const isNative = () => window.rvNative();

  function init(root) {
    if (!root || root.dataset.rvbInit) return;
    const holder = root.querySelector('script[data-rvb-data]');
    if (!holder) return;
    root.dataset.rvbInit = '1';
    const data = JSON.parse(holder.textContent);
    if (data.mode && !window.rvCheckoutMode) window.rvCheckoutMode = data.mode;
    const $$ = (s) => Array.from(root.querySelectorAll(s));
    const form = root.querySelector('.product-form');
    const idInput = () => root.querySelector('.product-purchase-form [name="id"]');
    const byId = (id) => data.variants.find((v) => String(v.id) === String(id));
    const colourOf = (v) => (data.colour > -1 ? v.o[data.colour] : '');
    const find = (colour, plan) => data.variants.find((v) => v.p === plan && (data.colour < 0 || v.o[data.colour] === colour));
    const noPlan = (v) => !!v && v.p === 'S' && !v.sp && isNative();
    const sellable = (v) => !!v && v.a && !noPlan(v);
    const decode = (s) => { const t = document.createElement('textarea'); t.innerHTML = s || ''; return t.value; };
    const mf = (() => {
      const m = /^(.*?)1(\D?)234(?:\2)567(\D)89(.*)$/.exec(decode(data.fmt));
      return m ? { pre: m[1], th: m[2], dec: m[3], suf: m[4] } : { pre: data.currency + ' ', th: "'", dec: '.', suf: '' };
    })();
    const fmt = (cents, trim) => {
      const whole = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, mf.th);
      const frac = String(cents % 100).padStart(2, '0');
      return mf.pre + whole + (trim && cents % 100 === 0 ? '' : mf.dec + frac) + mf.suf;
    };
    const accChecked = (plan) => $$('input[data-rvb-acc="' + plan + '"]').filter((i) => i.checked && !i.disabled);
    const accSum = (plan) => accChecked(plan).reduce((sum, i) => sum + (parseInt(i.dataset.c, 10) || 0), 0);
    let current = byId(idInput() && idInput().value) || data.variants[0];

    root.querySelectorAll('.product-form .input-row').forEach((row) => { if (row.querySelector(':scope > .option-selectors')) row.style.display = 'none'; });

    function setVariant(v) {
      if (!v || (current && v.id === current.id)) return;
      if (window.jQuery && window.theme && theme.OptionManager && theme.OptionManager.setVariant) {
        theme.OptionManager.setVariant(jQuery(form), v.id);
        return;
      }
      $$('.option-selector').forEach((sel) => {
        const value = v.o[parseInt(sel.dataset.optionIndex, 10)];
        if (sel.dataset.selectorType === 'dropdown') {
          sel.querySelector('.cc-select').dispatchEvent(new CustomEvent('selectOption', { detail: { value } }));
        } else {
          const input = Array.from(sel.querySelectorAll('input')).find((i) => i.value === value);
          if (input && !input.checked) { input.checked = true; input.dispatchEvent(new CustomEvent('change', { bubbles: true })); }
        }
      });
    }

    function nativeCover() {
      const addon = root.querySelector('[data-essential-upsell-funnel-content-offer-type="PRODUCT_ADDON"]');
      return addon ? addon.querySelector('input[type="checkbox"]') : null;
    }
    const cover = root.querySelector('.rvb-ins input[type="checkbox"]');
    const coverRow = cover ? cover.closest('.rvb-ins') : null;

    // Sold-out card (replaces the theme's "sold out" button and the Back in Stock app button, which stays the real trigger).
    const oos = root.querySelector('[data-rvb-oos]');
    const oosTitle = root.querySelector('[data-rvb-oos-title]');
    const oosText = root.querySelector('[data-rvb-oos-text]');
    const oosChips = root.querySelector('[data-rvb-oos-chips]');
    const notifyBtn = root.querySelector('[data-rvb-notify]');
    const noplan = root.querySelector('[data-rvb-noplan]');
    const noplanText = root.querySelector('[data-rvb-noplan-text]');
    const noplanChips = root.querySelector('[data-rvb-noplan-chips]');
    const shipN = root.querySelector('[data-rvb-ship-n]');
    const shipTxt = root.querySelector('[data-rvb-ship-txt]');
    const setText = (el, t) => { if (el && el.textContent !== t) el.textContent = t; };
    const setHidden = (el, h) => { if (el && el.hidden !== h) el.hidden = h; };
    const setShown = (el, on) => { if (!el) return; const d = on ? '' : 'none'; if (el.style.display !== d) el.style.display = d; };
    const notifyTrigger = () => root.querySelector('#BIS_trigger') || document.getElementById('BIS_trigger');
    const swatchOf = (colour) => { const i = $$('input[name^="rvb-colour-"]').find((x) => x.value === colour); return i ? i.nextElementSibling : null; };

    function fillChips(box, names) {
      if (!box) return;
      box.textContent = '';
      names.forEach((name) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'rvb-chip';
        b.dataset.rvbChip = name;
        const sw = swatchOf(name);
        if (sw && (sw.style.getPropertyValue('--sw') || sw.classList.contains('is-dots'))) {
          const dot = document.createElement('i');
          dot.setAttribute('aria-hidden', 'true');
          if (sw.classList.contains('is-dots')) dot.className = 'is-dots';
          else dot.style.setProperty('--sw', sw.style.getPropertyValue('--sw'));
          b.appendChild(dot);
        }
        b.appendChild(document.createTextNode(name));
        box.appendChild(b);
      });
      setHidden(box, !names.length);
    }
    const altColours = (v) => (data.colour > -1 ? Array.from(new Set(data.variants.filter((x) => x.p === v.p && sellable(x)).map(colourOf))) : []);

    function renderOos(v) {
      const off = !!v && !v.a;
      if (root.classList.contains('rvb-is-oos') !== off) root.classList.toggle('rvb-is-oos', off);
      if (!oos) return;
      setHidden(oos, !off);
      if (!off) return;
      const colour = colourOf(v);
      const alts = altColours(v);
      const key = v.id + '|' + alts.join('|');
      if (oos.dataset.key !== key) {
        oos.dataset.key = key;
        setText(oosTitle, colour ? data.oosTitle.replace('CC', colour) : data.oosTitleNone);
        setText(oosText, alts.length ? data.oosAlt : data.oosNone);
        fillChips(oosChips, alts);
      }
      setHidden(notifyBtn, !notifyTrigger());
    }

    // Native app only: a Subscribe variant without selling plan cannot be added (it would be sold once at the monthly price).
    function renderNoplan(v) {
      const off = !!v && v.a && noPlan(v);
      if (root.classList.contains('rvb-noplan-on') !== off) root.classList.toggle('rvb-noplan-on', off);
      if (!noplan) return;
      setHidden(noplan, !off);
      if (!off) return;
      const alts = altColours(v);
      const key = v.id + '|' + alts.join('|');
      if (noplan.dataset.key !== key) {
        noplan.dataset.key = key;
        setText(noplanText, alts.length ? data.noplanAlt : data.noplanNone);
        fillChips(noplanChips, alts);
      }
    }

    function productForm() {
      const i = idInput();
      return i && i.form ? i.form : root.querySelector('form.product-purchase-form');
    }
    function syncPlanInput() {
      const f = productForm();
      if (!f) return;
      let inp = f.querySelector('input[name="selling_plan"][data-rvb-sp]');
      const want = isNative() && current && current.p === 'S' && current.sp ? String(current.sp) : '';
      if (want) {
        if (!inp) {
          inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = 'selling_plan';
          inp.dataset.rvbSp = '1';
          f.appendChild(inp);
        }
        if (inp.value !== want) inp.value = want;
      } else if (inp) {
        inp.remove();
      }
    }
    function accPlan(input) {
      const list = (input.dataset.sps || '').split(',').filter(Boolean);
      if (!list.length) return null;
      return parseInt(current && current.sp && list.includes(String(current.sp)) ? current.sp : list[0], 10);
    }
    function syncAcc() {
      const native = isNative();
      $$('input[data-rvb-acc="S"]').forEach((i) => {
        const hide = native && !i.dataset.sps;
        if (hide && i.checked) i.checked = false;
        if (i.disabled !== hide) i.disabled = hide;
        setShown(i.closest('.rvb-eq__item'), !hide);
      });
      $$('.rvb-eq.rvb-only-S').forEach((fs) => {
        setShown(fs, Array.from(fs.querySelectorAll('input[data-rvb-acc]')).some((i) => !i.disabled));
      });
    }

    function render(v) {
      if (!v) return;
      current = v;
      const plan = v.p;
      const colour = colourOf(v);
      $$('.rvb').forEach((el) => { el.dataset.rvbPlan = plan; });
      $$('input[name^="rvb-plan-"]').forEach((i) => { i.checked = i.value === plan; i.closest('.rvb-plan').classList.toggle('is-selected', i.checked); });
      $$('input[name^="rvb-colour-"]').forEach((i) => {
        i.checked = i.value === colour;
        const ok = sellable(find(i.value, plan));
        const label = i.closest('.rvb-sw');
        label.classList.toggle('is-off', !ok);
        i.setAttribute('aria-label', i.value + (ok ? '' : ' (' + data.unavailable + ')'));
      });
      const name = root.querySelector('[data-rvb-colour-name]');
      if (name) name.textContent = colour;
      const s = find(colour, 'S');
      const n = find(colour, 'N');
      const ps = root.querySelector('[data-rvb-price="S"]');
      const pn = root.querySelector('[data-rvb-price="N"]');
      if (ps && s) ps.textContent = s.m;
      if (pn && n) pn.textContent = n.mz;
      if (plan === 'N') {
        if (cover) cover.checked = false;
      }
      syncCover();
      updateTotals();
    }

    function updateTotals() {
      const v = current;
      if (!v) return;
      const native = isNative();
      syncPlanInput();
      syncAcc();
      const spbOff = native && v.p === 'S';
      if (root.classList.contains('rvb-spb-off') !== spbOff) root.classList.toggle('rvb-spb-off', spbOff);
      const withCover = v.p === 'S' && !!(cover && cover.checked && !cover.disabled);
      const extra = (withCover ? data.ins : 0) + accSum(v.p);
      const total = extra ? fmt(v.c + extra, v.p === 'N') : (v.p === 'S' ? v.m : v.mz);
      const ts = root.querySelector('[data-rvb-total="S"]');
      const tn = root.querySelector('[data-rvb-total="N"]');
      if (v.p === 'S' && ts) ts.textContent = total;
      if (v.p === 'N' && tn) tn.textContent = total;
      const sp = root.querySelector('[data-rvb-sticky-price]');
      if (sp) sp.textContent = v.p === 'S' ? total + ' ' + data.month : total;
      if (shipN && v.p === 'N') {
        const free = v.c + accSum('N') >= data.freeShip;
        if (shipN.classList.contains('is-free') !== free) shipN.classList.toggle('is-free', free);
        setText(shipTxt, free ? data.shipFree : data.shipFrom);
      }
      renderOos(v);
      renderNoplan(v);
      const sn = root.querySelector('[data-rvb-sticky-name]');
      if (sn) sn.textContent = data.title + (colourOf(v) ? ' · ' + colourOf(v) : '');
      const sb = root.querySelector('[data-rvb-sticky-btn]');
      const main = root.querySelector('.product-purchase-form button[type="submit"]');
      if (sb) {
        const notify = !v.a && !!notifyTrigger();
        const off = notify ? false : (!v.a || noPlan(v) || !main || main.disabled);
        if (sb.disabled !== off) sb.disabled = off;
        const label = notify ? data.notifyShort : (main ? main.textContent.trim() : '');
        if (label && sb.textContent !== label) sb.textContent = label;
      }
    }

    function syncCover() {
      if (!cover) return;
      // The cover is added by this block (with its plan in native mode): the Essential Upsell add-on must stay unchecked.
      const nc = nativeCover();
      if (nc && nc.checked && !nc.disabled) nc.click();
      const ready = !!data.insId && (!isNative() || !!data.insSp);
      if (cover.disabled === ready) cover.disabled = !ready;
      coverRow.classList.toggle('is-waiting', !ready);
      if (!ready && cover.checked) cover.checked = false;
    }

    root.addEventListener('change', (e) => {
      const t = e.target;
      if (t.matches('input[name^="rvb-colour-"]')) {
        setVariant(find(t.value, current.p) || data.variants.find((v) => colourOf(v) === t.value));
      } else if (t.matches('input[name^="rvb-plan-"]')) {
        const colour = colourOf(current);
        setVariant(find(colour, t.value) || data.variants.find((v) => v.p === t.value && sellable(v)) || data.variants.find((v) => v.p === t.value && v.a) || data.variants.find((v) => v.p === t.value));
      } else if (cover && t === cover) {
        updateTotals();
      } else if (t.matches('input[data-rvb-acc]')) {
        updateTotals();
      } else if (t.matches('.product-purchase-form [name="id"]')) {
        render(byId(t.value));
      }
    });

    let bypass = false;
    root.addEventListener('submit', (e) => {
      const f = e.target;
      if (!f.matches || !f.matches('form.product-purchase-form')) return;
      if (bypass) { bypass = false; return; }
      const native = isNative();
      syncCover();
      if (native) {
        syncPlanInput();
        if (noPlan(current)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          renderNoplan(current);
          if (noplan) noplan.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }
      const items = [];
      if (current) {
        accChecked(current.p).forEach((i) => {
          const item = { id: parseInt(i.value, 10), quantity: 1 };
          if (native && current.p === 'S') {
            const sp = accPlan(i);
            if (!sp) return;
            item.selling_plan = sp;
          }
          items.push(item);
        });
        if (current.p === 'S' && cover && cover.checked && !cover.disabled && data.insId) {
          if (native && data.insSp) items.push({ id: data.insId, quantity: 1, selling_plan: data.insSp });
          else if (!native) items.push({ id: data.insId, quantity: 1 });
        }
      }
      if (!items.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const btn = f.querySelector('button[type="submit"]');
      if (btn) { btn.classList.add('btn--in-progress'); btn.disabled = true; }
      const rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      }).catch(() => null).then(() => {
        if (btn) { btn.classList.remove('btn--in-progress'); btn.disabled = false; }
        bypass = true;
        if (f.requestSubmit) f.requestSubmit(btn || undefined);
        else if (btn) btn.click();
        else { bypass = false; f.submit(); }
      });
    }, true);

    root.addEventListener('click', (e) => {
      const link = e.target.closest('[data-rvb-cover-link]');
      if (link) {
        const target = root.querySelector(link.getAttribute('href'));
        if (target) { e.preventDefault(); target.open = true; target.scrollIntoView({ behavior: 'smooth', block: 'start' }); target.querySelector('summary').focus({ preventScroll: true }); }
      }
      const chip = e.target.closest('[data-rvb-chip]');
      if (chip && current) {
        setVariant(find(chip.dataset.rvbChip, current.p));
        return;
      }
      const notify = e.target.closest('[data-rvb-notify]');
      const sticky = e.target.closest('[data-rvb-sticky-btn]');
      if (notify || (sticky && root.classList.contains('rvb-is-oos'))) {
        const t = notifyTrigger();
        if (t) t.click();
        return;
      }
      if (sticky) {
        const main = root.querySelector('.product-purchase-form button[type="submit"]');
        if (main && !main.disabled && !noPlan(current)) main.click();
      }
    });

    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      setTimeout(() => { queued = false; syncCover(); updateTotals(); }, 30);
    }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'checked'] });

    const bar = root.querySelector('.rvb-sticky');
    function watchButton() {
      const main = root.querySelector('.product-purchase-form button[type="submit"]');
      if (!bar || !main || !('IntersectionObserver' in window)) return;
      const seen = new Map();
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => seen.set(en.target, en.isIntersecting));
        const on = !Array.from(seen.values()).some(Boolean);
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        const b = bar.querySelector('button');
        if (b) b.tabIndex = on ? 0 : -1;
        document.body.classList.toggle('rvb-sticky-on', on && window.matchMedia('(max-width: 767px)').matches);
      });
      io.observe(main);
      if (oos) io.observe(oos);
      if (noplan) io.observe(noplan);
    }

    function start() {
      const v = byId(idInput() && idInput().value);
      if (v) render(v);
      syncCover();
      updateTotals();
      watchButton();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  }
  function initAll() {
    document.querySelectorAll('script[data-rvb-data]').forEach((s) => init(s.closest('[id^="shopify-section-"]')));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();